import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

const routesArray = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('./views/Blog.vue'),
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: () => import('./views/Portfolio.vue'),
  },
  {
    path: '/photography',
    name: 'photography',
    component: () => import('./views/Photography.vue'),
  },

  // 404 (route back to home page)
  { path: '*', name: '404', redirect: { name: 'home' } },
];

export const routes = routesArray.reduce((acc, x) => {
  acc[x.name] = x.path;
  return acc;
}, {});

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routesArray,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // Hash id somewhere down in the page
      return { selector: to.hash };
    } else if (savedPosition) {
      // Back/forward
      return savedPosition;
    } else {
      // To the top!
      return { x: 0, y: 0 };
    }
  },
});
